/**
 *	remove-class.directive.js
 */

import removeClass from './remove-class.link.js';

var makeItRedDirective = function() {
 	return {
 		restrict: 'A',
 		link: removeClass
 	};
 };

 export default makeItRedDirective;